import React, { useState } from "react";
import { Button, Form, Input, Alert, Card, Typography, Image, Divider } from "antd";
import { ENDPOINTS } from "../Services/ENDPOINT";
import logo from '../../assets/brand_logo1.png';

const { Title } = Typography;

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null); // { type: "success" | "error" | "info", message: "" }

  const sendOtp = async () => {
    setLoading(true);
    setAlert(null);
    try {
      const res = await fetch(`${ENDPOINTS.BASE}/auth/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      console.log("data", data);
      if (data.status === true) {
        setOtpSent(true);
        setAlert({ type: "success", message: "OTP sent successfully!" });
      } else {
        setAlert({ type: "error", message: data.message || "Failed to send OTP" });
      }
    } catch (error) {
      console.log("error", error);
      setAlert({ type: "error", message: "Something went wrong" });
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (values) => {
    setLoading(true);
    setAlert(null);
    try {
      const res = await fetch(`${ENDPOINTS.BASE}/auth/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp: values.otp }),
      });
      const data = await res.json();
      if (data.status === false) {
        setAlert({ type: "error", message: data.message || "Invalid OTP" });
        return;
      }
      localStorage.setItem("user_key", data.user_key || data.token || email);
      localStorage.setItem("user_info", JSON.stringify(data.user || {}));
      localStorage.setItem("user_permissions", JSON.stringify(data.permissions || []));
      setAlert({ type: "success", message: "Login successful!" });

      window.location.reload();
    } catch (error) {
      console.log(error);
      setAlert({ type: "error", message: "Something went wrong" });

    } finally {
      setLoading(false);
    }
  };

  return (
    <Card style={{ maxWidth: 430, margin: "80px auto" }}
      actions={[
        <Typography.Text type="secondary">
          Powered by<a
            href="https://shreeshtech.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            shreeshtech
          </a>
        </Typography.Text>,
      ]}
    >

      <Image src={logo} preview={false} />

      <Divider />
      <Title level={3}>Admin Login</Title>

      {alert && (
        <Alert
          message={alert.message}
          type={alert.type}
          showIcon
          closable
          onClose={() => setAlert(null)}
          style={{ marginBottom: 16 }}
        />
      )}

      {!otpSent ? (
        <Form layout="vertical" onFinish={sendOtp}>
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Please enter email" },
              { type: "email", message: "Please enter valid email" },
            ]}
          >
            <Input
              size="large"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Form.Item>
          <Button size="large" type="primary" htmlType="submit" loading={loading} block>
            Send OTP
          </Button>
        </Form>
      ) : (
        <Form layout="vertical" onFinish={verifyOtp}>
          <Form.Item
            label="OTP"
            name="otp"
            rules={[{ required: true, message: "Please enter OTP" }]}
          >
            <Input placeholder="Enter OTP" size="large" />
          </Form.Item>
          <Button type="primary" size="large" htmlType="submit" loading={loading} block>
            Verify OTP
          </Button>
          <div style={{
            display: 'flex', justifyContent: 'space-between'
          }}>
            <Button
              type="link"
              onClick={sendOtp}
              loading={loading}
              style={{ paddingLeft: 0, marginTop: 8 }}

            >
              Retry / Resend OTP
            </Button>

            <Button
              type="link"
              onClick={() => setOtpSent(false)}
              loading={loading}
              style={{ paddingLeft: 0, marginTop: 8 }}
            >
              Back
            </Button>
          </div>

        </Form>
      )}
    </Card>
  );
}